import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { Review } from './review'

export class ReviewsRepository extends BaseRepository<Review> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/nps/reviews', token, cache)
    }

    async notes() {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl + '/nps/reviews/notes/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async setStatus(reviewId: string, status: number) {
        const { json, statusCode, message } = await this.request.post(
            this.config.toolsApiUrl + '/nps/reviews/' + reviewId + '/status/?token=' + this.resolvedToken,
            { status },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async setSentToGoogle(reviewId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl + '/nps/reviews/' + reviewId + '/sent/',
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
